import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ContingentService } from '../../services/contingent/contingent.service';
import { ContingentBundleApiActions, ContingentBundleActions } from './contingent-bundle.actions';
import { switchMap, map, catchError, of } from 'rxjs';

@Injectable()
export class ContingentBundleEffects {
    constructor(
        private actions$: Actions,
        private contingentService: ContingentService
    ) {}

    loadContingentBundles$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ContingentBundleApiActions.loadContingentBundles),
            switchMap(() =>
                this.contingentService.loadContingentBundles().pipe(
                    map((contingentBundles) => ContingentBundleActions.loadContingentBundlesSuccess({ contingentBundles })),
                    catchError((error) => of(ContingentBundleActions.loadContingentBundlesFailure({ error })))
                )
            )
        );
    });
}
